class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick =
      this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    if (facetForm) {
      facetForm.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }

    const facetWrapper = this.querySelector(
      '#FacetsWrapperDesktop'
    );

    if (facetWrapper) {
      facetWrapper.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }

    const facetButton = this.querySelector(
      '.facets__button-show'
    );

    if (facetButton) {
      facetButton.onclick = () => {
        this.querySelector('.facets__wrapper')
          ?.classList.toggle('active');
      };

      const closeButton = this.querySelector(
        '.facets__close'
      );

      if (closeButton) {
        closeButton.onclick = () => {
          this.querySelector('.facets__wrapper')
            ?.classList.remove('active');
        };
      }
    }

    document.addEventListener('click', (event) => {
      const detailsList = document.querySelectorAll(
        '.facets__wrapper--horizontal .facets__disclosure'
      );

      const details = event.target.closest(
        '.facets__disclosure[open]'
      );

      const facetsHorizontal = document.querySelector(
        '.facets__wrapper--horizontal_united'
      );

      const parent = event.target.closest(
        '.facets__wrapper--horizontal_united'
      );

      const overlay = event.target.closest(
        '.loading-overlay'
      );

      if (facetsHorizontal) {
        if (
          facetsHorizontal !== parent &&
          document.querySelector('.facets__button-show') !==
            event.target.closest('.facets__button-show') &&
          document.querySelector('.loading-overlay') !== overlay
        ) {
          facetsHorizontal.classList.remove('active');
        }
      }

      if (!details && detailsList.length) {
        detailsList.forEach((item) => {
          item.removeAttribute('open');
        });
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (
        searchParams ===
        FacetFiltersForm.searchParamsPrev
      ) {
        return;
      }

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false
      );
    };

    window.addEventListener(
      'popstate',
      onHistoryChange
    );
  }

  static toggleActiveFacets(disable = true) {
    document
      .querySelectorAll('.js-facet-remove')
      .forEach((element) => {
        element.classList.toggle(
          'disabled',
          disable
        );
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {
    FacetFiltersForm.searchParamsPrev =
      searchParams;

    const countContainer =
      document.getElementById('ProductCount');

    const countContainerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    const facetsHorizontalActive =
      document.querySelector(
        '.facets__wrapper--horizontal_united.active'
      );

    const productGridContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    const collection =
      productGridContainer?.querySelector(
        '.collection'
      );

    if (collection) {
      collection.classList.add('loading');
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add(
        'loading'
      );
    }

    const loadingOverlay =
      document.querySelector('.loading-overlay');

    if (loadingOverlay) {
      loadingOverlay.style.top =
        facetsHorizontalActive
          ? '-5.6rem'
          : '0';
    }

    const collectionUrl =
      productGridContainer?.dataset
        .collectionUrl ||
      window.location.pathname;

    const requestUrl = new URL(
      collectionUrl,
      window.location.origin
    );

    requestUrl.searchParams.set(
      'view',
      'membership-filter'
    );

    new URLSearchParams(searchParams).forEach(
      (value, key) => {
        requestUrl.searchParams.set(
          key,
          value
        );
      }
    );

    const url = requestUrl.toString();

    const cachedResponse =
      FacetFiltersForm.filterData.find(
        (item) => item.url === url
      );

    if (cachedResponse) {
      FacetFiltersForm.renderSectionFromCache(
        cachedResponse,
        event
      );
    } else {
      FacetFiltersForm.renderSectionFromFetch(
        url,
        event
      );
    }

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(
        searchParams
      );
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Facet request failed: ${response.status} ${response.statusText}`
          );
        }

        return response.text();
      })
      .then((html) => {
        FacetFiltersForm.filterData.push({
          html,
          url
        });

        FacetFiltersForm.renderFilters(
          html,
          event
        );

        FacetFiltersForm
          .renderProductGridContainer(html);

        FacetFiltersForm
          .renderProductCount(html);
      })
      .catch((error) => {
        console.error(
          'Membership facet request error:',
          error
        );

        document
          .querySelector(
            '#ProductGridContainer .collection'
          )
          ?.classList.remove('loading');
      });
  }

  static renderSectionFromCache(
    cachedResponse,
    event
  ) {
    const html = cachedResponse.html;

    FacetFiltersForm.renderFilters(
      html,
      event
    );

    FacetFiltersForm
      .renderProductGridContainer(html);

    FacetFiltersForm
      .renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const scrollY = window.scrollY;
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const sourceGrid =
      parsedHTML.getElementById(
        'ProductGridContainer'
      );

    const targetGrid =
      document.getElementById(
        'ProductGridContainer'
      );

    if (!sourceGrid || !targetGrid) {
      console.error(
        'Membership product grid was not returned.'
      );

      return;
    }

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    targetGrid.innerHTML =
      sourceGrid.innerHTML;

    window.scrollTo(0, scrollY);

    if (
      document.querySelector(
        '.js-load-more'
      ) ||
      document.querySelector(
        '.js-infinite-scroll'
      )
    ) {
      if (typeof loadMore === 'function') {
        loadMore();
      }
    }

    if (
      typeof colorSwatches === 'function'
    ) {
      colorSwatches();
    }
  }

  static renderProductCount(html) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const count =
      parsedHTML.getElementById(
        'ProductCount'
      )?.innerHTML;

    const container =
      document.getElementById(
        'ProductCount'
      );

    const containerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    if (count && container) {
      container.innerHTML = count;
      container.classList.remove('loading');

      if (containerDesktop) {
        containerDesktop.innerHTML = count;

        containerDesktop.classList.remove(
          'loading'
        );
      }
    }

    const loadingOverlay =
      document.querySelector(
        '.loading-overlay'
      );

    if (loadingOverlay) {
      loadingOverlay.style.top = '0';
    }
  }

  static renderFilters(html, event) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const sourceDesktopWrapper =
      parsedHTML.getElementById(
        'FacetsWrapperDesktop'
      );

    const targetDesktopWrapper =
      document.getElementById(
        'FacetsWrapperDesktop'
      );

    if (
      sourceDesktopWrapper &&
      targetDesktopWrapper
    ) {
      targetDesktopWrapper.innerHTML =
        sourceDesktopWrapper.innerHTML;

      targetDesktopWrapper.className =
        sourceDesktopWrapper.className;
    }

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, ' +
        '#FacetFiltersFormMobile .js-filter, ' +
        '#FacetFiltersPillsForm .js-filter'
      );

    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest('.js-filter')
        : undefined;

      return jsFilter
        ? element.dataset.index ===
            jsFilter.dataset.index
        : false;
    };

    const facetsToRender =
      Array.from(
        facetDetailsElements
      ).filter(
        (element) =>
          !matchesIndex(element)
      );

    const countsToRender =
      Array.from(
        facetDetailsElements
      ).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const currentElement =
        document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`
        );

      if (currentElement) {
        currentElement.innerHTML =
          element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );

    FacetFiltersForm
      .renderAdditionalElements(parsedHTML);

    if (
      countsToRender &&
      event?.target
    ) {
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(
          '.js-filter'
        )
      );
    }
  }

  static renderActiveFacets(html) {
    const selectors = [
      '.active-facets-mobile',
      '.active-facets-desktop'
    ];

    selectors.forEach((selector) => {
      const sourceElement =
        html.querySelector(selector);

      const targetElement =
        document.querySelector(selector);

      if (
        !sourceElement ||
        !targetElement
      ) {
        return;
      }

      targetElement.innerHTML =
        sourceElement.innerHTML;
    });

    FacetFiltersForm
      .toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const selectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting'
    ];

    selectors.forEach((selector) => {
      const sourceElement =
        html.querySelector(selector);

      const targetElement =
        document.querySelector(selector);

      if (
        !sourceElement ||
        !targetElement
      ) {
        return;
      }

      targetElement.innerHTML =
        sourceElement.innerHTML;
    });

    const mobileForm =
      document.getElementById(
        'FacetFiltersFormMobile'
      );

    const menuDrawer =
      mobileForm?.closest('menu-drawer');

    if (
      menuDrawer &&
      typeof menuDrawer.bindEvents ===
        'function'
    ) {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetElement =
      target.querySelector(
        '.facets__selected'
      );

    const sourceElement =
      source.querySelector(
        '.facets__selected'
      );

    const targetSummary =
      target.querySelector(
        '.facets__summary'
      );

    const sourceSummary =
      source.querySelector(
        '.facets__summary'
      );

    if (
      sourceElement &&
      targetElement
    ) {
      targetElement.outerHTML =
        sourceElement.outerHTML;
    }

    if (
      targetSummary &&
      sourceSummary
    ) {
      targetSummary.outerHTML =
        sourceSummary.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const url =
      `${window.location.pathname}${
        searchParams
          ? `?${searchParams}`
          : ''
      }`;

    history.pushState(
      {
        searchParams
      },
      '',
      url
    );
  }

  createSearchParams(form) {
    const formData =
      new FormData(form);

    return new URLSearchParams(
      formData
    ).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms =
      document.querySelectorAll(
        'facet-filters-form form'
      );

    const currentForm =
      event.target.closest('form');

    const isMobile =
      currentForm?.id ===
      'FacetFiltersFormMobile';

    if (
      event.target.classList.contains(
        'mobile-facets__checkbox'
      )
    ) {
      const searchParams =
        this.createSearchParams(
          currentForm
        );

      this.onSubmitForm(
        searchParams,
        event
      );

      return;
    }

    const forms = [];

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id ===
            'FacetSortForm' ||
          form.id ===
            'FacetFiltersForm' ||
          form.id ===
            'FacetSortDrawerForm'
        ) {
          document
            .querySelectorAll(
              '.no-js-list'
            )
            .forEach((element) => {
              element.remove();
            });

          forms.push(
            this.createSearchParams(form)
          );
        }
      } else if (
        form.id ===
        'FacetFiltersFormMobile'
      ) {
        forms.push(
          this.createSearchParams(form)
        );
      }
    });

    this.onSubmitForm(
      forms.join('&'),
      event
    );
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm
      .toggleActiveFacets();

    const href =
      event.currentTarget.href;

    const queryIndex =
      href.indexOf('?');

    const searchParams =
      queryIndex === -1
        ? ''
        : href.slice(
            queryIndex + 1
          );

    const cleanedParams =
      new URLSearchParams(
        searchParams
      );

    cleanedParams.delete('view');

    FacetFiltersForm.renderPage(
      cleanedParams.toString()
    );
  }
}

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

if (
  !customElements.get(
    'facet-filters-form'
  )
) {
  customElements.define(
    'facet-filters-form',
    FacetFiltersForm
  );
}

FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input')
      .forEach((element) => {
        element.addEventListener(
          'change',
          this.onRangeChange.bind(this)
        );
      });

    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(
      event.currentTarget
    );

    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs =
      this.querySelectorAll('input');

    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) {
      minInput.setAttribute(
        'max',
        maxInput.value
      );
    }

    if (minInput.value) {
      maxInput.setAttribute(
        'min',
        minInput.value
      );
    }

    if (minInput.value === '') {
      maxInput.setAttribute('min', 0);
    }

    if (maxInput.value === '') {
      minInput.setAttribute(
        'max',
        maxInput.getAttribute('max')
      );
    }
  }

  adjustToValidValues(input) {
    const value =
      Number(input.value);

    const min =
      Number(
        input.getAttribute('min')
      );

    const max =
      Number(
        input.getAttribute('max')
      );

    if (value < min) {
      input.value = min;
    }

    if (value > max) {
      input.value = max;
    }
  }

  fillSlider() {
    document
      .querySelectorAll(
        '.facets__price .facets__range'
      )
      .forEach((inputWrapper) => {
        const inputsRange =
          inputWrapper.querySelectorAll(
            '.field__range'
          );

        const inputRangeFrom =
          inputsRange[0];

        const inputRangeTo =
          inputsRange[1];

        if (
          !inputRangeFrom ||
          !inputRangeTo
        ) {
          return;
        }

        const range =
          inputRangeTo.max -
          inputRangeTo.min;

        const fromCurrent =
          inputRangeFrom.value -
          inputRangeTo.min;

        const toCurrent =
          inputRangeTo.value -
          inputRangeTo.min;

        const minRange =
          (fromCurrent / range) * 100;

        const maxRange =
          (toCurrent / range) * 100;

        inputWrapper.setAttribute(
          'style',
          `--range-min: ${minRange}%; --range-max: ${maxRange}%`
        );
      });
  }

  controlSlider() {
    const inputRangeWrappers =
      document.querySelectorAll(
        '.facets__price .facets__range'
      );

    const inputNumberWrappers =
      document.querySelectorAll(
        '.facets__price .facets__price-wrapper'
      );

    inputRangeWrappers.forEach(
      (inputWrapper, index) => {
        const inputsRange =
          inputWrapper.querySelectorAll(
            '.field__range'
          );

        const inputRangeFrom =
          inputsRange[0];

        const inputRangeTo =
          inputsRange[1];

        const numberWrapper =
          inputNumberWrappers[index];

        if (
          !inputRangeFrom ||
          !inputRangeTo ||
          !numberWrapper
        ) {
          return;
        }

        const numberInputs =
          numberWrapper.querySelectorAll(
            '.field__input'
          );

        const inputNumberFrom =
          numberInputs[0];

        const inputNumberTo =
          numberInputs[1];

        inputRangeFrom.oninput =
          () => {
            const from =
              Number(
                inputRangeFrom.value
              );

            const to =
              Number(
                inputRangeTo.value
              );

            if (from > to) {
              inputRangeFrom.value =
                to;

              inputNumberFrom.value =
                to;
            } else {
              inputNumberFrom.value =
                from;
            }

            this.fillSlider();
          };

        inputRangeTo.style.zIndex =
          Number(
            inputRangeTo.value
          ) <= 0
            ? 2
            : 0;

        inputRangeTo.oninput =
          () => {
            const from =
              Number(
                inputRangeFrom.value
              );

            const to =
              Number(
                inputRangeTo.value
              );

            if (from <= to) {
              inputRangeTo.value =
                to;

              inputNumberTo.value =
                to;
            } else {
              inputNumberTo.value =
                from;

              inputRangeTo.value =
                from;
            }

            inputRangeTo.style.zIndex =
              Number(
                inputRangeTo.value
              ) <= 0
                ? 2
                : 0;

            this.fillSlider();
          };
      }
    );
  }

  controlInput() {
    const inputRangeWrappers =
      document.querySelectorAll(
        '.facets__price .facets__range'
      );

    const inputNumberWrappers =
      document.querySelectorAll(
        '.facets__price .facets__price-wrapper'
      );

    inputNumberWrappers.forEach(
      (inputWrapper, index) => {
        const inputsNumber =
          inputWrapper.querySelectorAll(
            '.field__input'
          );

        const inputNumberFrom =
          inputsNumber[0];

        const inputNumberTo =
          inputsNumber[1];

        const rangeWrapper =
          inputRangeWrappers[index];

        if (
          !inputNumberFrom ||
          !inputNumberTo ||
          !rangeWrapper
        ) {
          return;
        }

        const inputsRange =
          rangeWrapper.querySelectorAll(
            '.field__range'
          );

        const inputRangeFrom =
          inputsRange[0];

        const inputRangeTo =
          inputsRange[1];

        inputNumberFrom.oninput =
          () => {
            const from =
              Number(
                inputNumberFrom.value
              );

            const to =
              Number(
                inputNumberTo.value
              );

            inputRangeFrom.value =
              to && from > to
                ? to
                : from;

            this.fillSlider();
          };

        inputNumberTo.oninput =
          () => {
            const from =
              Number(
                inputNumberFrom.value
              );

            const to =
              Number(
                inputNumberTo.value
              );

            inputRangeTo.value =
              from <= to
                ? to
                : from;

            this.fillSlider();
          };

        inputNumberFrom.onblur =
          () => {
            const from =
              Number(
                inputNumberFrom.value
              );

            const min =
              Number(
                inputNumberFrom.getAttribute(
                  'min'
                )
              );

            if (from < min) {
              inputRangeFrom.value =
                min;

              inputNumberFrom.value =
                min;
            } else {
              inputRangeFrom.value =
                from;
            }

            this.fillSlider();
          };

        inputNumberTo.onblur =
          () => {
            const to =
              Number(
                inputNumberTo.value
              );

            const max =
              Number(
                inputNumberTo.getAttribute(
                  'max'
                )
              );

            if (to > max) {
              inputRangeTo.value =
                max;

              inputNumberTo.value =
                max;
            } else {
              inputRangeTo.value =
                to;
            }

            this.fillSlider();
          };
      }
    );
  }
}

if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    PriceRange
  );
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink =
      this.querySelector('a');

    if (!facetLink) return;

    facetLink.setAttribute(
      'role',
      'button'
    );

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(this)
    );

    facetLink.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code.toUpperCase() !==
          'SPACE'
        ) {
          return;
        }

        event.preventDefault();
        this.closeFilter(event);
      }
    );
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest(
        'facet-filters-form'
      ) ||
      document.querySelector(
        'facet-filters-form'
      );

    if (form) {
      form.onActiveFilterClick(
        event
      );
    }
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define(
    'facet-remove',
    FacetRemove
  );
}

/*
 * Keep pagination on the membership page and load
 * the requested collection page through AJAX.
 */
document.addEventListener('click', (event) => {
  const paginationLink = event.target.closest(
    '#ProductGridContainer .pagination a'
  );

  if (!paginationLink) return;

  event.preventDefault();

  const paginationUrl = new URL(
    paginationLink.href,
    window.location.origin
  );

  paginationUrl.searchParams.delete('view');

  FacetFiltersForm.renderPage(
    paginationUrl.searchParams.toString()
  );
});

/*
 * Handle the dynamically loaded filter close button.
 */
document.addEventListener('click', (event) => {
  const closeButton = event.target.closest(
    '.facets__close'
  );

  if (!closeButton) return;

  event.preventDefault();

  closeButton
    .closest(
      '.facets__wrapper--horizontal_united'
    )
    ?.classList.remove('active');
});